import { debounce } from "rxjs/operator/debounce";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  NgZone,
  ComponentRef
} from "@angular/core";
import { IMyDpOptions, MyDatePicker } from "mydatepicker";
import { ACCESSIBLE_CHANNEL_TYPE, ENDPOINTS, USER_ROLES } from "../app.config";
import axios from "axios";
import * as urlRegex from "url-regex";
import { parseZone } from "moment";
import { ToasterService } from "angular2-toaster";
import {
  debugOutputAstAsTypeScript,
  StaticAndDynamicReflectionCapabilities
} from "@angular/compiler";
import { CompanyService } from "../company.service";
import { UserInfoService } from "../shared/user-info.service";
import { ActivatedRoute, Router } from "@angular/router";
@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["./news.component.css"],
  providers: [UserInfoService]
})
export class NewsComponent implements OnInit {
  constructor(
    toaster: ToasterService,
    private userInfoService: UserInfoService,
    companyService: CompanyService,
    route: ActivatedRoute,
    router: Router
  ) {
    this.toaster = toaster;
    this.companyService = companyService;
    this.router = router;
    this.route = route;
  }
  router: Router;
  @ViewChild("newsForm")
  newsform: ElementRef;
  @ViewChild("validfromdate")
  validfromdateelement: ElementRef;
  dragItem: any;
  orderingInProgress: boolean;
  // valid from date time variables
  valid_from_min: any = "00";
  valid_from_hour: any = "00";
  valid_from_date: any;
  // valid to date time variables
  valid_to_min: "";
  valid_to_hour: "";
  valid_to_date: any;
  fromDate: any;
  toDate: any;
  fromDate_u: any;
  toDate_u: any;
  searchfilter_p: any;
  searchfilter_u: any;
  partofurl_p: any;
  partofurl_u: any;
  //news object to bind with UI
  newNews = {
    title: "",
    description: "",
    icon: "",
    valid_from: "",
    valid_to: "",
    is_published: false,
    url: ""
  };
  public errorFields = [];
  publishednewslist: NewsTable[];
  unpublishednewslist: NewsTable[];
  mydate: any;
  today: any;
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: "dd.mm.yyyy"
  };
  //Paging vars
  newslistsTotal: number;
  newslistsPerPage: number;
  totalPages: number;
  currentPage: number;
  gettingNewslistsInProgress: boolean;
  invalidurl: boolean = false;
  invalidurlNewsId: number;
  toaster: ToasterService;

  //for bread crumbs
  businesOwnerName: string;
  businessOwnerIdLocalStorage = localStorage.getItem("businessOwnerId");
  userRole: string;
  dropdownSettings = {};
  companyName: string;
  companyId: string;
  channelsList = [];
  route: ActivatedRoute;
  sub: any;
  companyService: CompanyService;

  ngOnInit() {
    let d: Date = new Date();

    this.valid_from_date = {
      date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() }
    };
    let tdy = {
      date: {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate()
      },
      time: { hour: d.getHours(), minute: d.getMinutes() }
    };
    this.today =
      tdy.date.year +
      "-" +
      (tdy.date.month < 10 ? "0" + tdy.date.month : tdy.date.month) +
      "-" +
      (tdy.date.day < 10 ? "0" + tdy.date.day : tdy.date.day) +
      "T" +
      tdy.time.hour +
      ":" +
      tdy.time.minute +
      ":00.000Z";

    this.currentPage = 1;
    this.newslistsPerPage = 10;

    this.orderingInProgress = false;
    this.getAllPublishedNews("");
    this.getAllUnPublishedNews("");
    this.gettingNewslistsInProgress = false;
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.companyService.setCompanyId(this.companyId);
      this.getUserInfo();
    });
  }
  getAllPublishedNews(partofurl, applydatefilter = false, applysearch = false) {
    ;
    let url =
      ENDPOINTS.GET_NEWS_ALL +
      "?published=true" +
      "&page=" +
      this.currentPage +
      "&per_page=" +
      this.newslistsPerPage;
    if (applydatefilter) {
      url += partofurl;
    }
    if (applysearch) {
      url += "&q=" + this.searchfilter_p;
    }

    axios.get(url).then(response => {
      ;
      console.table(response.data);
      this.publishednewslist = response.data;
      let length = this.publishednewslist.length;
      for (let i = 0; i < length; i++) {
        // ;
        let index = this.publishednewslist[i].created_at.indexOf("T");
        let create_datetime = this.publishednewslist[i].created_at;
        let create_date = create_datetime.substr(0, index);
        let create_time = create_datetime.substr(index + 1, 8);
        let dateformat = create_date.split("-");
        let formatteddate =
          dateformat.length > 0
            ? dateformat[2] + "." + dateformat[1] + "." + dateformat[0]
            : create_date;
        this.publishednewslist[i].created_at =
          formatteddate + " " + create_time;
        //For Valid from date and time
        if (this.publishednewslist[i].valid_from) {
          let len = this.publishednewslist[i].valid_from.length;
          let index = this.publishednewslist[i].valid_from.indexOf("T");
          let datetime = this.publishednewslist[i].valid_from;
          let date = datetime.substr(0, index);
          let time = datetime.substr(index + 1, 5);
          this.publishednewslist[i].valid_from_date = {
            date: {
              year: date.substr(0, 4),
              month:
                parseInt(date.substr(5, 2)) < 10
                  ? date.substr(6, 1)
                  : date.substr(5, 2),
              day:
                parseInt(date.substr(8, 2)) < 10
                  ? date.substr(9, 1)
                  : date.substr(8, 2)
            }
          };
          this.publishednewslist[i].valid_from_hour = time.substr(0, 2);
          this.publishednewslist[i].valid_from_min = time.substr(3, 2);
        }
        //fro valid to date and time
        if (this.publishednewslist[i].valid_to) {
          let len = this.publishednewslist[i].valid_to.length;
          let index = this.publishednewslist[i].valid_to.indexOf("T");
          let datetime = this.publishednewslist[i].valid_to;
          let date = datetime.substr(0, index);
          let time = datetime.substr(index + 1, 5);
          this.publishednewslist[i].valid_to_date = {
            date: {
              year: date.substr(0, 4),
              month:
                parseInt(date.substr(5, 2)) < 10
                  ? date.substr(6, 1)
                  : date.substr(5, 2),
              day:
                parseInt(date.substr(8, 2)) < 10
                  ? date.substr(9, 1)
                  : date.substr(8, 2)
            }
          };
          this.publishednewslist[i].valid_to_hour = time.substr(0, 2);
          this.publishednewslist[i].valid_to_min = time.substr(3, 2);
        }
        //for icon dropdown
        if (this.publishednewslist[i].icon) {
          if (this.publishednewslist[i].icon.indexOf("energetika") > 0) {
            this.publishednewslist[i].icon = "energetika";
          } else if (this.publishednewslist[i].icon.indexOf("kinodvor") > 0) {
            this.publishednewslist[i].icon = "festival-kinodvor";
          } else if (this.publishednewslist[i].icon.indexOf("grad") > 0) {
            this.publishednewslist[i].icon = "grad";
          } else if (this.publishednewslist[i].icon.indexOf("lpp") > 0) {
            this.publishednewslist[i].icon = "lpp";
          } else if (this.publishednewslist[i].icon.indexOf("lpt") > 0) {
            this.publishednewslist[i].icon = "lpt";
          } else if (this.publishednewslist[i].icon.indexOf("mol") > 0) {
            this.publishednewslist[i].icon = "mol";
          } else if (this.publishednewslist[i].icon.indexOf("muzej") > 0) {
            this.publishednewslist[i].icon = "muzej";
          } else if (this.publishednewslist[i].icon.indexOf("sport") > 0) {
            this.publishednewslist[i].icon = "sport";
          } else if (this.publishednewslist[i].icon.indexOf("voka") > 0) {
            this.publishednewslist[i].icon = "voka";
          } else if (this.publishednewslist[i].icon.indexOf("zoo") > 0) {
            this.publishednewslist[i].icon = "zoo";
          }
        }
      }
    });
  }

  SearchNews_P() {
    const _self = this;
    setTimeout(() => {
      ;
      if (_self.searchfilter_p && (_self.fromDate || _self.toDate)) {
        _self.getAllPublishedNews(_self.partofurl_p, true, true);
      } else if (_self.searchfilter_p && !(_self.fromDate || _self.toDate)) {
        _self.getAllPublishedNews("", false, true);
      }else if (this.fromDate && this.toDate) {
        let url = "&from=" + _self.fromDate.formatted + "&to=" + _self.toDate.formatted;
        _self.getAllPublishedNews(url, true, false);
      } else if (this.fromDate) {
        let url = "&from=" + _self.fromDate.formatted;
        _self.getAllPublishedNews(url, true, false);
      } else if (this.toDate) {
        let url = "&to=" + _self.toDate.formatted;
        _self.getAllPublishedNews(url, true, false);
      } else _self.getAllPublishedNews("");
    }, 500);
  }

  SearchNews_U() {
    const _self = this;
    setTimeout(() => {
      if (_self.searchfilter_u && (_self.fromDate_u || _self.toDate_u)) {
        _self.getAllUnPublishedNews(_self.partofurl_u, true, true);
      } else if (
        _self.searchfilter_u &&
        !(_self.fromDate_u || _self.toDate_u)
      ) {
        _self.getAllUnPublishedNews("", false, true);
      } else if (_self.fromDate_u && _self.toDate_u) {
        let url =
          "&from=" +
          _self.fromDate_u.formatted +
          "&to=" +
          _self.toDate_u.formatted;

        _self.getAllUnPublishedNews(url, true, false);
      } else if (_self.fromDate_u) {
        let url = "&from=" + _self.fromDate_u.formatted;
        _self.getAllUnPublishedNews(url, true, false);
      } else if (_self.toDate_u) {
        let url = "&to=" + _self.toDate_u.formatted;
        _self.getAllUnPublishedNews(url, true, false);
      } else {
        debugger;
        _self.getAllUnPublishedNews("");
      }
    }, 500);
  }

  getAllUnPublishedNews(
    partofurl,
    applydatefilter = false,
    applysearch = false
  ) {
    let url = ENDPOINTS.GET_NEWS_ALL + "?published=false";
    if (applydatefilter) {
      url += partofurl;
    }
    if (applysearch) {
      url += "&q=" + this.searchfilter_u;
    }
    axios.get(url).then(response => {
      this.unpublishednewslist = response.data;
      //console.log(this.unpublishednewslist);
      let length = this.unpublishednewslist.length;
      for (let i = 0; i < length; i++) {
        let index = this.unpublishednewslist[i].created_at.indexOf("T");
        let create_datetime = this.unpublishednewslist[i].created_at;
        let create_date = create_datetime.substr(0, index);
        let create_time = create_datetime.substr(index + 1, 8);
        let dateformat = create_date.split("-");
        let formatteddate =
          dateformat.length > 0
            ? dateformat[2] + "." + dateformat[1] + "." + dateformat[0]
            : create_date;

        this.unpublishednewslist[i].created_at =
          formatteddate + " " + create_time;
        //For Valid from date and time
        if (this.unpublishednewslist[i].valid_from) {
          let len = this.unpublishednewslist[i].valid_from.length;
          let index = this.unpublishednewslist[i].valid_from.indexOf("T");
          let datetime = this.unpublishednewslist[i].valid_from;
          let date = datetime.substr(0, index);
          let time = datetime.substr(index + 1, 5);
          this.unpublishednewslist[i].valid_from_date = {
            date: {
              year: date.substr(0, 4),
              month:
                parseInt(date.substr(5, 2)) < 10
                  ? date.substr(6, 1)
                  : date.substr(5, 2),
              day:
                parseInt(date.substr(8, 2)) < 10
                  ? date.substr(9, 1)
                  : date.substr(8, 2)
            }
          };
          this.unpublishednewslist[i].valid_from_hour = time.substr(0, 2);
          this.unpublishednewslist[i].valid_from_min = time.substr(3, 2);
        }
        //fro valid to date and time
        if (this.unpublishednewslist[i].valid_to) {
          let len = this.unpublishednewslist[i].valid_to.length;
          let index = this.unpublishednewslist[i].valid_to.indexOf("T");
          let datetime = this.unpublishednewslist[i].valid_to;
          let date = datetime.substr(0, index);
          let time = datetime.substr(index + 1, 5);
          this.unpublishednewslist[i].valid_to_date = {
            date: {
              year: date.substr(0, 4),
              month:
                parseInt(date.substr(5, 2)) < 10
                  ? date.substr(6, 1)
                  : date.substr(5, 2),
              day:
                parseInt(date.substr(8, 2)) < 10
                  ? date.substr(9, 1)
                  : date.substr(8, 2)
            }
          };
          this.unpublishednewslist[i].valid_to_hour = time.substr(0, 2);
          this.unpublishednewslist[i].valid_to_min = time.substr(3, 2);
        }
        // for icon dropdown
        if (this.unpublishednewslist[i].icon) {
          if (this.unpublishednewslist[i].icon.indexOf("energetika") > 0) {
            this.unpublishednewslist[i].icon = "energetika";
          } else if (this.unpublishednewslist[i].icon.indexOf("kinodvor") > 0) {
            this.unpublishednewslist[i].icon = "festival-kinodvor";
          } else if (this.unpublishednewslist[i].icon.indexOf("grad") > 0) {
            this.unpublishednewslist[i].icon = "grad";
          } else if (this.unpublishednewslist[i].icon.indexOf("lpp") > 0) {
            this.unpublishednewslist[i].icon = "lpp";
          } else if (this.unpublishednewslist[i].icon.indexOf("lpt") > 0) {
            this.unpublishednewslist[i].icon = "lpt";
          } else if (this.unpublishednewslist[i].icon.indexOf("mol") > 0) {
            this.unpublishednewslist[i].icon = "mol";
          } else if (this.unpublishednewslist[i].icon.indexOf("muzej") > 0) {
            this.unpublishednewslist[i].icon = "muzej";
          } else if (this.unpublishednewslist[i].icon.indexOf("sport") > 0) {
            this.unpublishednewslist[i].icon = "sport";
          } else if (this.unpublishednewslist[i].icon.indexOf("voka") > 0) {
            this.unpublishednewslist[i].icon = "voka";
          } else if (this.unpublishednewslist[i].icon.indexOf("zoo") > 0) {
            this.unpublishednewslist[i].icon = "zoo";
          }
        }
      }
    });
  }

  validateNewNews() {
    this.errorFields = [];
    if (!this.newNews.icon) {
      this.errorFields.push("icon");
    }
    if (!this.newNews.title) {
      this.errorFields.push("title");
    }
    if (!this.newNews.description) {
      this.errorFields.push("description");
    }
    if (!this.isUrlInputValid(this.newNews.url)) {
      this.errorFields.push("url");
    }

    if (!this.valid_from_hour) {
      this.errorFields.push("valid_from_hour");
    }
    if (!this.valid_from_min) {
      this.errorFields.push("valid_from_min");
    }
    if (!this.valid_from_date) {
      this.errorFields.push("valid_from_date");
    }
    // if (!this.valid_to_hour) {
    //   this.errorFields.push('valid_to_hour');
    // }
    // if (!this.valid_to_min) {
    //   this.errorFields.push('valid_to_min');
    // }
    // if (this.valid_to_date) {

    // }
    // if (!this.newNews.is_published) {
    //   this.errorFields.push('is_published');
    // }

    if (this.valid_from_date && this.valid_from_hour && this.valid_from_min)
      this.newNews.valid_from =
        this.valid_from_date.date.year +
        "-" +
        this.valid_from_date.date.month +
        "-" +
        this.valid_from_date.date.day +
        " " +
        this.valid_from_hour +
        ":" +
        this.valid_from_min;
    if (this.valid_to_date && this.valid_to_hour && this.valid_to_min)
      this.newNews.valid_to =
        this.valid_to_date.date.year +
        "-" +
        this.valid_to_date.date.month +
        "-" +
        this.valid_to_date.date.day +
        " " +
        this.valid_to_hour +
        ":" +
        this.valid_to_min;
    else if (this.valid_to_date && !this.valid_to_hour && !this.valid_to_min)
      this.newNews.valid_to =
        this.valid_to_date.date.year +
        "-" +
        this.valid_to_date.date.month +
        "-" +
        this.valid_to_date.date.day +
        " 23:59";
    else if (this.valid_to_date && this.valid_to_hour && !this.valid_to_min)
      this.newNews.valid_to =
        this.valid_to_date.date.year +
        "-" +
        this.valid_to_date.date.month +
        "-" +
        this.valid_to_date.date.day +
        " " +
        this.valid_to_hour +
        ":59";
    else if (this.valid_to_date && !this.valid_to_hour && this.valid_to_min)
      this.newNews.valid_to =
        this.valid_to_date.date.year +
        "-" +
        this.valid_to_date.date.month +
        "-" +
        this.valid_to_date.date.day +
        " 23:" +
        this.valid_to_min;
    return this.errorFields.length === 0;
  }

  isUrlInputValid(urladdress: string) {
    let isValid = urlRegex().test(urladdress);
    if (!isValid) {
      this.errorFields.push("urlAddress");
    } else if (this.errorFields.includes("urlAddress")) {
      let index = this.errorFields.indexOf("urlAddress");
      this.errorFields.splice(index, 1);
    }
    return isValid;
  }
  addNewNews() {
    const _self = this;

    const isNewsValid = this.validateNewNews();
    const data = {
      title: this.newNews.title,
      description: this.newNews.description,
      icon: this.newNews.icon,
      valid_from: this.newNews.valid_from,
      valid_to: this.newNews.valid_to,
      is_published: this.newNews.is_published,
      url: this.newNews.url
    };
    if (isNewsValid) {
      axios.post(ENDPOINTS.POST_NEWS, data).then(
        response => {
          _self.getAllPublishedNews("");
          _self.getAllUnPublishedNews("");
          _self.toaster.pop("success", "News Successfully added");
          let d: Date = new Date();
          let validfrom = {
            date: {
              year: d.getFullYear(),
              month: d.getMonth() + 1,
              day: d.getDate()
            }
          };
          _self.newNews = {
            title: "",
            description: "",
            icon: "",
            valid_from: "" + validfrom,
            valid_to: "",
            is_published: false,
            url: ""
          };
          // this.validfromdateelement.nativeElement.value = { date: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}};
        },
        error => {
          _self.toaster.pop("error", error.response.data.message);
        }
      );
      return isNewsValid;
    } else {
      _self.toaster.pop("error", "Invalid or incomplete data");
      return isNewsValid;
    }
  }

  handleTime(time, value) {
    let parsedValue = parseInt(this[value], 10);
    if (time === "hours") {
      if (isNaN(parsedValue)) {
        if (value.includes("from")) {
          parsedValue = 8;
          this[value] = "08";
        } else {
          parsedValue = 18;
          this[value] = "18";
        }
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        this[value] = "0" + parsedValue.toString();
      }
      if (parsedValue < 0) {
        this[value] = "00";
      }
      if (parsedValue > 23) {
        this[value] = "23";
      }
    } else {
      if (isNaN(parsedValue)) {
        parsedValue = 0;
      }
      if (parsedValue < 10 && parsedValue >= 0) {
        this[value] = "0" + parsedValue.toString();
      }
      if (parsedValue < 0) {
        this[value] = "00";
      }
      if (parsedValue > 59) {
        this[value] = "59";
      }
    }
    const fromHours = parseInt(this["fromHours"], 10);
    const fromMinutes = parseInt(this["fromMinutes"], 10);
    const toHours = parseInt(this["toHours"], 10);
    const toMinutes = parseInt(this["toMinutes"], 10);
    if (fromHours * 60 + fromMinutes > toHours * 60 + toMinutes) {
      this.valid_to_hour = this.valid_from_hour;
      this.valid_to_min = this.valid_from_min;
    }
  }

  handleTime_unpublishtable(time, fromto, value, id) {
    if (value < 10 && value >= 0) {
      value = "0" + value;
    } else if (value < 0) {
      value = "00";
    }

    if (time === "hours") {
      if (value > 23) {
        value = "23";
      }
      if (fromto === "from") {
        this.unpublishednewslist.find(p => p.id == id).valid_from_hour = value;
      } else if (fromto === "to") {
        this.unpublishednewslist.find(p => p.id == id).valid_to_hour = value;
      }
    } else if (time === "minutes") {
      if (value > 59) {
        value = "59";
      }
      if (fromto === "from") {
        this.unpublishednewslist.find(p => p.id == id).valid_from_min = value;
      } else if (fromto === "to") {
        this.unpublishednewslist.find(p => p.id == id).valid_to_min = value;
      }
    }
  }

  handleTime_publishtable(time, fromto, value, id) {
    if (value < 10 && value >= 0) {
      value = "0" + value;
    } else if (value < 0) {
      value = "00";
    }

    if (time === "hours") {
      if (value > 23) {
        value = "23";
      }
      if (fromto === "from") {
        this.publishednewslist.find(p => p.id == id).valid_from_hour = value;
      } else if (fromto === "to") {
        this.publishednewslist.find(p => p.id == id).valid_to_hour = value;
      }
    } else if (time === "minutes") {
      if (value > 59) {
        value = "59";
      }
      if (fromto === "from") {
        this.publishednewslist.find(p => p.id == id).valid_from_min = value;
      } else if (fromto === "to") {
        this.publishednewslist.find(p => p.id == id).valid_to_min = value;
      }
    }
  }

  orderNews(
    newsItem,
    position,
    continueWith?: () => void,
    disablePlaylistReload?: boolean
  ) {
    if (this.orderingInProgress) {
      return;
    }
    this.orderingInProgress = true;
    const _self = this;
    axios
      .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", newsItem.id), {
        id: newsItem.id,
        position
      })
      .then(
        res => {
          _self.orderingInProgress = false;

          if (!disablePlaylistReload) {
            _self.getAllPublishedNews("");
          }

          continueWith && continueWith();
        },
        error => {
          _self.orderingInProgress = false;
        }
      );
  }

  releaseDrop(sourceNews: any, targetNews: any, targetOffset: number) {
    if (this.orderingInProgress) {
      return;
    }

    const self = this;

    if (sourceNews && targetNews) {
      let news = this.publishednewslist as Array<any>; //Array.from(this.playlist.playlist_assets as Array<any>);
      const sourceIndex = news.findIndex(x => x.id == sourceNews.id);
      const targetIndex = news.findIndex(x => x.id == targetNews.id);
      const targetNewsPosition = targetNews.position;
      sourceNews = news[sourceIndex];

      self.orderingInProgress = true;

      const allAssetsDone = new Array<boolean>(news.length);

      let addAmout = 0;

      if (sourceIndex > targetIndex) {
        addAmout = 1;
      }

      news.splice(targetIndex + targetOffset, 0, news[sourceIndex]);
      news.splice(sourceIndex + addAmout, 1);

      for (let i = 0; i < news.length; i++) {
        const asset = news[i];
        const index = i;
        asset.position = i + 1;
      }

      axios
        .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", sourceNews.id), {
          id: sourceNews.id,
          position: sourceNews.position
        })
        .then(
          res => {
            self.orderingInProgress = false;
          },
          error => {
            self.orderingInProgress = false;
          }
        );
    }

    this.endDrag();
  }

  releaseDropUp(sourceNews: any, targetNews: any) {
    this.releaseDrop(sourceNews, targetNews, 0);
  }

  releaseDropDown(sourceNews: any, targetNews: any) {
    this.releaseDrop(sourceNews, targetNews, 1);
  }

  startDrag(item: any) {
    this.dragItem = item;
  }

  endDrag() {
    this.dragItem = null;
  }

  ManagePublishNews(id, is_publish) {
    axios
      .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", id), {
        id: id,
        is_published: is_publish
      })
      .then(
        res => {
          this.getAllPublishedNews("");
          this.getAllUnPublishedNews("");
        },
        error => {}
      );
  }

  Delete(id: any) {
    const _self = this;
    if (id > 0) {
      axios.delete(ENDPOINTS.DELETE_NEWS.replace(":newsId", id)).then(
        response => {
          _self.getAllUnPublishedNews("");
          _self.toaster.pop("success", "News Successfully Deleted");
        },
        error => {
          _self.toaster.pop("error", error.response.data.message);
        }
      );
    } else {
      _self.toaster.pop("error", "Invalid or incomplete data");
    }
  }

  updateNews(newsupdate, field, date = null) {
    if (field == "title") {
      axios
        .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", newsupdate.id), {
          title: newsupdate.title
        })
        .then(response => {}, error => {});
    } else if (field == "icon") {
      axios
        .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", newsupdate.id), {
          icon: newsupdate.icon
        })
        .then(response => {}, error => {});
    } else if (field == "description") {
      axios
        .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", newsupdate.id), {
          description: newsupdate.description
        })
        .then(response => {}, error => {});
    } else if (field == "url") {
      if (this.isUrlInputValid(newsupdate.url)) {
        axios
          .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", newsupdate.id), {
            url: newsupdate.url
          })
          .then(response => {}, error => {});
      } else {
        this.invalidurl = true;
        this.invalidurlNewsId = newsupdate.id;
      }
    } else if (field == "validfrom") {
      axios
        .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", newsupdate.id), {
          valid_from:
            date.year +
            "-" +
            (date.month < 10 ? "0" + date.month : date.month) +
            "-" +
            (date.day < 10 ? "0" + date.day : date.day) +
            "T" +
            (!newsupdate.valid_from_hour ? "00" : newsupdate.valid_from_hour) +
            ":" +
            (!newsupdate.valid_from_min ? "00" : newsupdate.valid_from_min) +
            ":00.000Z"
        })
        .then(response => {}, error => {});
    } else if (field == "validto") {
      let vldto = null;
      if (
        date.day == 0 &&
        date.month == 0 &&
        date.year == 0 &&
        !newsupdate.valid_to_hour &&
        !newsupdate.valid_to_min
      ) {
        vldto = null;
      } else if (
        !(date.day == 0 && date.month == 0 && date.year == 0) &&
        !newsupdate.valid_to_hour &&
        !newsupdate.valid_to_min
      ) {
        vldto = date.year + "-" + date.month + "-" + date.day;
      } else {
        vldto =
          date.year +
          "-" +
          (date.month < 10 ? "0" + date.month : date.month) +
          "-" +
          (date.day < 10 ? "0" + date.day : date.day) +
          "T" +
          (!newsupdate.valid_to_hour ? "00" : newsupdate.valid_to_hour) +
          ":" +
          (!newsupdate.valid_to_min ? "00" : newsupdate.valid_to_min) +
          ":00.000Z";
      }

      axios
        .patch(ENDPOINTS.PUT_NEWS.replace(":newsId", newsupdate.id), {
          valid_to: vldto
        })
        .then(
          response => {
            this.unpublishednewslist.find(
              p => p.id == newsupdate.id
            ).valid_to = vldto;
          },
          error => {}
        );
    }
  }

  NewsKeyDown(e: KeyboardEvent) {
    if (e.keyCode == 13 && !e.shiftKey) {
      // prevent default behavior
      e.preventDefault();
    }
  }

  preserveDefault() {
    let d: Date = new Date();

    this.valid_from_date = {
      date: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() }
    };
    this.valid_from_min = "00";
    this.valid_from_hour = "00";
    this.valid_to_date = null;
    this.valid_to_hour = null;
    this.valid_to_min = null;
  }

  onDateChanged_P(event) {
    const _self = this;
    ;
    console.log(_self);
    setTimeout(() => {
      let partofurl = "";
      ;
      if (_self.toDate && _self.fromDate) {
        partofurl =
          "&from=" + _self.fromDate.formatted + "&to=" + _self.toDate.formatted;
      } else if (!_self.toDate && _self.fromDate) {
        partofurl = "&from=" + _self.fromDate.formatted;
      } else if (_self.toDate && !_self.fromDate) {
        partofurl = "&to=" + _self.toDate.formatted;
      } else if (!_self.toDate && !_self.fromDate) {
        partofurl = "";
      }
      this.partofurl_p = partofurl;

      if (this.searchfilter_p && this.searchfilter_p != "") {
        _self.getAllPublishedNews(partofurl, true, true); //partofurl,applydatefilter,applysearch
      } else _self.getAllPublishedNews(partofurl, true);
    }, 500);
  }

  onDateChanged_U(event) {
    const _self = this;

    setTimeout(() => {
      let partofurl = "";
      if (_self.toDate_u && _self.fromDate_u) {
        partofurl =
          "&from=" +
          _self.fromDate_u.formatted +
          "&to=" +
          _self.toDate_u.formatted;
      } else if (!_self.toDate_u && _self.fromDate_u) {
        partofurl = "&from=" + _self.fromDate_u.formatted;
      } else if (_self.toDate_u && !_self.fromDate_u) {
        partofurl = "&to=" + _self.toDate_u.formatted;
      } else if (!_self.toDate_u && !_self.fromDate_u) {
        partofurl = "";
      }

      this.partofurl_u = partofurl;
      if (this.searchfilter_u && this.searchfilter_u != "") {
        _self.getAllUnPublishedNews(partofurl, true, true); //partofurl,applydatefilter,applysearch
      } else _self.getAllUnPublishedNews(partofurl, true);
    }, 500);
  }

  onFromDateChanged(event) {
    // const _self = this;
    // if (_self.toDate) {
    //   setTimeout(() => {
    //     _self.getAssets(true);
    //   }, 500);
    // } else {
    //   _self.getAssets(false);
    // }
  }

  //#Paging Published Table
  // initPagingVars(response) {
  //   const _self = this;
  //   _self.newslistsTotal = parseInt(response.headers['total'], 10);
  //   _self.newslistsPerPage = parseInt(response.headers['per-page'], 10);
  //   _self.totalPages = Math.floor(
  //     _self.newslistsTotal % _self.newslistsPerPage,
  //   ) === 0
  //     ? _self.newslistsTotal / _self.newslistsPerPage
  //     : Math.floor(_self.newslistsTotal / _self.newslistsPerPage) + 1;
  // }

  // loadNewslists(page, isDisabled) {

  //   if (!isDisabled && !this.gettingNewslistsInProgress) {
  //     this.currentPage = page;
  //     this.getAllPublishedNews();
  //   }
  // }

  // generatePages() {
  //   if (!this.totalPages) {
  //     return [];
  //   }
  //   const arr = [];
  //   for (let i = 0; i < this.totalPages; i++) {
  //     arr.push(i + 1);
  //   }
  //   return arr;
  // }

  getUserInfo() {
    const _self = this;

    this.userInfoService.getInformations().subscribe(info => {
      _self.businessOwnerIdLocalStorage = localStorage.getItem(
        "businessOwnerId"
      );
      _self.userRole = info.userRole;
      _self.companyName = info.companyName;
      _self.businesOwnerName = info.businesOwnerName;

      if (
        _self.userRole !== USER_ROLES.COMPANY_VIEWER &&
        _self.userRole !== USER_ROLES.COMPANY_EDITOR
      ) {
        _self.getCompanyInfo();
      }
      if (_self.userRole === USER_ROLES.COMPANY_EDITOR) {
        _self.dropdownSettings["hideRemoveButton"] = true;
      }
      if (_self.userRole === USER_ROLES.COMPANY_VIEWER) {
        _self.dropdownSettings["disabled"] = true;
      }
    });
  }

  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + "/" + _self.companyId)
      .then(response => {
        _self.companyName = response.data.name;
        _self.channelsList = _self.generateChannelsList(response.data.channels);
      });
  }
  generateChannelsList(channels) {
    const channelsList = [];
    for (const item of channels) {
      channelsList.push({
        id: item.id,
        itemName: item.name
      });
    }
    return channelsList;
  }
}
interface NewsTable {
  id: "";
  title: "";
  description: "";
  icon: any;
  valid_from: "";
  valid_to: "";
  valid_from_hour: any;
  valid_from_min: any;
  valid_from_date: any;
  valid_to_hour: any;
  valid_to_min: any;
  valid_to_date: any;
  is_published: false;
  url: "";
  created_at: any;
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/news/news.component.ts